var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"py-2 text-sm font-semibold border-b-2 cursor-pointer select-none",class:{ 'border-green-500 text-black': _vm.value === _vm.name, 'border-transparent text-gray-500': _vm.value !== _vm.name },on:{"click":_vm.click}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }